import React, { FC, ReactElement } from 'react';
import { ZTooltip } from '../../../../../../widgets/ztooltip';

// I MENU «…» DICONO SOLO IL NOME DEL COMANDO (utente, 2026-10-15): Clone, Remove, Move si capiscono da soli, e
// un sottotitolo sotto ognuno allungava il menu senza dire niente di nuovo. I comandi meno ovvi — Copy to,
// Replace in, Preview image, Merge, Retarget — spiegano che cosa fanno in un suggerimento, al passaggio.
export const ComposerMenuHint: FC<{ hint: string; children: ReactElement }> = ({ hint, children }) => (
    <ZTooltip addContainer compact position='left' title={hint}>
        {children}
    </ZTooltip>
);
